/**
 * Viewer-Anfragen (Sammel-Nachbesserung B-2).
 *
 * Rechtsfrage und KI-Antwort gehen nur im JSON-Rumpf eines POST an den Server, nie als
 * URL-Parameter: Eine URL steht im Zugriffsprotokoll des Webservers, im Browserverlauf und
 * in Proxy-Protokollen. Der Pfad bleibt deshalb immer ohne Abfrageteil.
 */

export type ViewerArt = 'ris' | 'rag';

export interface ViewerTarget {
  art: ViewerArt;
  ziel: string;
}

export interface ViewerRequest {
  path: string;
  init: {
    method: 'POST';
    credentials: 'include';
    headers: Record<string, string>;
    body: string;
  };
}

const RAG_PREFIX = 'document://';

/** Erkennt, ob der Viewer ein RIS-Dokument (URL) oder ein RAG-Dokument (`document://<id>`) zeigt. */
export function viewerTarget(url: string): ViewerTarget {
  return url.startsWith(RAG_PREFIX)
    ? { art: 'rag', ziel: url.slice(RAG_PREFIX.length) }
    : { art: 'ris', ziel: url };
}

/** Baut die POST-Anfrage; `path` ist relativ und wird vom Aufrufer mit `buildApiUrl` ergaenzt. */
export function viewerRequest(art: ViewerArt, ziel: string, query: string, context?: string): ViewerRequest {
  // Ohne Frage gibt es nichts hervorzuheben; der Server nimmt eine leere Frage nur zusammen mit skipHighlighting an.
  const zusatz = { ...(context ? { context } : {}), ...(query.trim() ? {} : { skipHighlighting: true }) };
  const rumpf = art === 'ris'
    ? { url: ziel, query, ...zusatz }
    : { documentId: ziel, query, ...zusatz };
  return {
    path: art === 'ris' ? '/api/ris/viewer' : '/api/ris/document-viewer',
    init: {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(rumpf),
    },
  };
}
